<mat-card>
  <mat-card-title>Cette page vous permet de gérer les liens vers les formulaires</mat-card-title>
  <mat-card-subtitle>le lien vers le formulaire est unique, que cela soit pour vos formulaires ou pour d'autres gestionnaires</mat-card-subtitle>
  <mat-card-content>
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100%">
        <div fxFlexAlign="end" fxLayout="rows" fxLayoutGap="10px">
          <mat-checkbox
            matTooltip="Tous les formulaires, publiées ou non"
            style="font-size: 0.8rem; font-weight: 500;"
            (change)="onStateFiltered($event)" data-cy="chkbx-url-list-all-forms">
            Tous les formulaires
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div>
      <app-data-table *ngIf="extraParams"
        [actions]="actions"
        [columns]="columns"
        [dataSource]="dsUrls"
        [extraParams]="extraParams"
        [filterDisplay]="true"
        [flexAction]="5"
        [flexColumn]="90"
        [fontSizeCell]="'0.9em'"
        [minFilter]="1" [pageSize]="10"
        [pageSizesList]="[5,10,25]" [placeHolderFilter]="'Recherche sur le nom d\'un formulaire ou d\'un raccourci'"
        [refreshButton]="true"
        [refreshIcone]="false"
        [showFirstLastButtons]="true"
        [showLoader]="true"
        [loaderMask]="true"
        [toolTipFilter]="'Recherche sur le nom d\'un formulaire ou d\'un raccourci'">
      </app-data-table>
    </div>
  </mat-card-content>
</mat-card>
